import { Component } from "react";

export default class ChunkErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.routeKey !== this.props.routeKey) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="chunk-error-retry"
          className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6"
        >
          <p className="text-[#0f292f] text-base font-medium">
            Si è verificato un problema nel caricamento di questa pagina.
          </p>
          <p className="text-[#666] text-sm mt-2">
            Controlla la connessione e riprova.
          </p>
          <button
            data-testid="chunk-error-retry-btn"
            onClick={() => window.location.reload()}
            className="mt-6 bg-[#0f292f] text-white px-6 py-3 rounded-full text-sm font-medium hover:bg-[#0f292f]/85 transition-all"
          >
            Riprova
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
